export enum TileColour {
  DEFAULT = 'bg-[linear-gradient(223.42deg,_#083382_15.3%,_#14CBC5_119.84%)]',
  GREEN = 'bg-[linear-gradient(230.78deg,_#117E47_50.49%,_#1EDE7E_109.42%)]',
  VIOLET = 'bg-[linear-gradient(230.78deg,#6D10D0_50.49%,#BF3ED9_109.42%)]',
  BLUE = 'bg-[linear-gradient(228.32deg,_#2310D0_19.15%,_#3E7FD9_101.74%)]',
  YELLOW = 'bg-[linear-gradient(228.32deg,_rgba(255,239,3,1)_0%,_rgba(255,239,3,0.95)_40%,_rgba(255,239,3,0.8)_85%,_rgba(255,239,3,0.6)_120%)]',
  RED = 'bg-[linear-gradient(230.78deg,_#b64632_50.49%,_#e8705a_109.42%)]',
}
